export var isValidElement = function (jsxCode) {
    var jsxRegex = /react|\.jsx|children:\[\(/i;
    return jsxRegex.test(jsxCode);
};
